import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";

export interface IntentosClienteFinalResponse {
  data: IntentoDetalle[];
  pagination: {
    page: number;
    limit: number;
    total: number;
  };
}

export interface IntentoDetalle {
  id: number;
  archivo: any; // JSON con información del archivo
  retroalimentacion: any; // JSON con retroalimentación
  creadoEl: string;
  actividad: {
    id: number;
    nombre: string;
    programa: {
      id: number;
      nombre: string;
    };
  };
  aprendiz: {
    id: number;
    idUsuario: number;
    nombre: string;
    apellidoPaterno: string;
    apellidoMaterno: string | null;
    correo: string;
    clienteFinal: {
      id: number;
      nombreEmpresa: string;
    };
  };
}

export const useIntentosPorClienteFinal = (
  clienteFinalId: number | null,
  params?: {
    page?: number;
    limit?: number;
    dateFrom?: string;
    dateTo?: string;
    programaId?: number;
    actividadId?: number;
  }
) => {
  return useQuery<IntentosClienteFinalResponse, Error>({
    queryKey: ["intentosPorClienteFinal", clienteFinalId, params],
    queryFn: async () => {
      if (!clienteFinalId) {
        throw new Error("clienteFinalId is required");
      }
      const response = await axiosInstance.get(
        `/analytics/clientes-finales/${clienteFinalId}/intentos`,
        {
          params: {
            ...(params?.page && { page: params.page }),
            ...(params?.limit && { limit: params.limit }),
            ...(params?.dateFrom && { dateFrom: params.dateFrom }),
            ...(params?.dateTo && { dateTo: params.dateTo }),
            ...(params?.programaId && { programaId: params.programaId }),
            ...(params?.actividadId && { actividadId: params.actividadId }),
          },
        }
      );
      return response.data;
    },
    enabled: !!clienteFinalId,
    placeholderData: keepPreviousData,
  });
};
